import React from 'react'
import './JobHeader.css'
import PageTitle from '../global/PageTitle/PageTitle'
export default function JobHeader() {
  return (
    <div class ="jobHeader">
       <PageTitle title="Create Job Requisition" />
      <div className="header-content">
      Please <a className="job-header-link" href="#">click here</a>
      <span class="hgl">
        to see user guide on How to Create a Job Requisition.
      </span>
      To monitor progress and see candidates for your requisition. To monitor
      progress and see candidates for your requisition(s),
       use the <span class="hgl"> Recruiting tab of the Manager Dashboard.</span> There are
      additional resources on the <a className="job-header-link"href="#">Workday Resources page </a> for general
      navigation and other helpful user guides. <br/>
      <br/>
      <span class="hgl">The copy Details from Existing
      Requisition</span>  function has been disabled. please do not select <span class="hgl"> Copy Details
      from Existing Requisition </span>
      </div>
      <br/><br></br>
      <hr/><br/>
    </div>
  )
}